export default __webpack_public_path__ + "static/media/1172.01c529e2.png";